import { render, staticRenderFns } from "./TheAppMenu.vue?vue&type=template&id=bbf2a188&scoped=true&"
import script from "./TheAppMenu.vue?vue&type=script&lang=js&"
export * from "./TheAppMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheAppMenu.vue?vue&type=style&index=0&id=bbf2a188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf2a188",
  null
  
)

export default component.exports